import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Contact form submitted:", formData);
    alert("Thank you for contacting us! We'll get back to you soon.");
    setFormData({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
    });
  };

  const contactMethods = [
    {
      icon: "📞",
      title: "Call Us",
      desc: "Available 24/7 for urgent matters",
      contact: "+94 71 978 0187",
    },
    {
      icon: "📧",
      title: "Email Us",
      desc: "We respond within 24 hours",
      contact: "admin@pahanmi.live",
    },
    {
      icon: "📍",
      title: "Visit Us",
      desc: "Sri Lanka",
      contact: "Manel, Maha Kowana, Hindagolla, Kurunegala, Sri Lanka.",
    },
    {
      icon: "🕐",
      title: "Business Hours",
      desc: "We're here to help",
      contact: "Mon - Fri: 9:00 AM - 6:00 PM",
    },
  ];

  return (
    <>
      <style>{`
        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-40px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(40px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        @keyframes iconSpin {
          0%, 100% {
            transform: scale(1) rotate(0deg);
          }
          50% {
            transform: scale(1.1) rotate(5deg);
          }
        }

        .contact-header {
          animation: slideInUp 0.8s ease-out;
        }

        .contact-methods {
          animation: fadeIn 0.8s ease-out 0.2s both;
        }

        .contact-method {
          animation: scaleIn 0.6s ease-out;
          transition: all 0.3s ease;
        }

        .contact-method:nth-child(1) { animation-delay: 0.2s; }
        .contact-method:nth-child(2) { animation-delay: 0.3s; }
        .contact-method:nth-child(3) { animation-delay: 0.4s; }
        .contact-method:nth-child(4) { animation-delay: 0.5s; }

        .contact-icon {
          animation: bounce 2s ease-in-out infinite;
          transition: all 0.3s ease;
          display: inline-block;
        }

        .contact-method:hover .contact-icon {
          animation: iconSpin 0.6s ease-in-out;
        }

        .contact-method:hover {
          transform: translateY(-10px) scale(1.05);
          box-shadow: 0 20px 40px rgba(13, 157, 173, 0.2);
          border-color: #1A7A7A;
        }

        .contact-form-section {
          animation: slideInRight 0.8s ease-out 0.3s both;
        }

        .faq-section {
          animation: slideInLeft 0.8s ease-out 0.3s both;
        }

        .faq-item {
          animation: slideInUp 0.6s ease-out;
          transition: all 0.3s ease;
        }

        .faq-item:nth-child(1) { animation-delay: 0.35s; }
        .faq-item:nth-child(2) { animation-delay: 0.4s; }
        .faq-item:nth-child(3) { animation-delay: 0.45s; }
        .faq-item:nth-child(4) { animation-delay: 0.5s; }

        .faq-item:hover {
          transform: translateX(8px);
          border-color: #1A7A7A;
        }

        .form-input {
          animation: slideInUp 0.6s ease-out;
          transition: all 0.3s ease;
        }

        .form-input:focus {
          transform: scale(1.02);
          box-shadow: 0 0 0 3px rgba(13, 157, 173, 0.1);
        }

        .submit-btn {
          animation: slideInUp 0.6s ease-out 1.2s both;
          transition: all 0.3s ease;
        }

        .submit-btn:hover {
          transform: scale(1.05) translateY(-2px);
          box-shadow: 0 15px 35px rgba(13, 157, 173, 0.3);
        }
      `}</style>
      <section id="contact" className="py-24 bg-white relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#0D9DAD]/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#1A7A7A]/10 rounded-full blur-3xl" />

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          {/* Header */}
          <div className="text-center max-w-3xl mx-auto mb-16 contact-header">
            <span className="inline-flex items-center gap-2 bg-slate-100 border border-slate-300 rounded-full px-4 py-2 text-sm font-semibold text-[#1A7A7A] mb-6">
              <span className="w-2 h-2 bg-[#1A7A7A] rounded-full" />
              Get In Touch
            </span>
            <h2 className="text-4xl sm:text-5xl font-bold text-[#062B45] mb-6 leading-tight">
              We'd Love to Hear From You
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed">
              Have questions about HelaDoc? Need support? Want to partner with us? Reach out and we'll be happy to help.
            </p>
          </div>

          {/* Contact Methods */}
          <div className="contact-methods grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {contactMethods.map((method, index) => (
            <div
              key={index}
              className="contact-method bg-white/60 backdrop-blur-lg border border-gray-200 rounded-xl p-6 text-center hover:border-[#1A7A7A]/30 transition-all duration-300"
            >
              <div className="contact-icon text-4xl mb-4">{method.icon}</div>
              <h3 className="text-lg font-bold text-[#062B45] mb-2">{method.title}</h3>
              <p className="text-xs text-gray-500 mb-3">{method.desc}</p>
              <p className="text-sm font-semibold text-[#1A7A7A]">{method.contact}</p>
            </div>
          ))}
        </div>

        {/* Main Contact Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* FAQ/Info */}
          <div className="faq-section space-y-6">
            <div>
              <h3 className="text-2xl font-bold text-[#062B45] mb-4">Frequently Asked Questions</h3>
              <p className="text-gray-600 mb-8">
                Find answers to common questions about our services, booking appointments, and more.
              </p>
            </div>

            {[
              {
                q: "How do I book an appointment?",
                a: "You can easily book appointments through our mobile app. Select your preferred doctor, time slot, and complete the booking.",
              },
              {
                q: "What payment methods do you accept?",
                a: "We accept all major credit/debit cards, mobile payments (Dialog, Airtel), bank transfers, and digital wallets.",
              },
              {
                q: "Is my medical data secure?",
                a: "Yes, all your health information is encrypted and stored securely according to international healthcare data protection standards.",
              },
              {
                q: "Do you offer emergency services?",
                a: "Yes, we have 24/7 emergency support. Call our hotline for immediate medical assistance.",
              },
            ].map((faq, index) => (
              <div
                key={index}
                className="bg-[#F4F7F9] rounded-lg p-6 border border-gray-200 hover:border-[#1A7A7A]/30 transition-all"
              >
                <h4 className="font-bold text-[#062B45] mb-2">{faq.q}</h4>
                <p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p>
              </div>
            ))}
          </div>

          {/* Contact Form */}
          <div className="contact-form-section">
            <form
              onSubmit={handleSubmit}
              className="bg-white/80 backdrop-blur-lg border border-gray-200 rounded-2xl p-8 shadow-xl"
            >
              <h3 className="text-2xl font-bold text-[#062B45] mb-6">Send us a Message</h3>

              {/* Name */}
              <div className="mb-4">
                <label className="block text-sm font-semibold text-[#062B45] mb-2">
                  Your Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="form-input w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#1A7A7A] focus:ring-2 focus:ring-[#1A7A7A]/20 outline-none transition-all"
                  placeholder="John Doe"
                  style={{ animationDelay: "0.7s" }}
                />
              </div>

              {/* Email */}
              <div className="mb-4">
                <label className="block text-sm font-semibold text-[#062B45] mb-2">
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#1A7A7A] focus:ring-2 focus:ring-[#1A7A7A]/20 outline-none transition-all"
                  placeholder="john@example.com"
                />
              </div>

              {/* Phone */}
              <div className="mb-4">
                <label className="block text-sm font-semibold text-[#062B45] mb-2">
                  Phone Number
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#1A7A7A] focus:ring-2 focus:ring-[#1A7A7A]/20 outline-none transition-all"
                  placeholder="+94 123 456 7890"
                />
              </div>

              {/* Subject */}
              <div className="mb-4">
                <label className="block text-sm font-semibold text-[#062B45] mb-2">
                  Subject
                </label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#1A7A7A] focus:ring-2 focus:ring-[#1A7A7A]/20 outline-none transition-all"
                  placeholder="How can we help?"
                />
              </div>

              {/* Message */}
              <div className="mb-6">
                <label className="block text-sm font-semibold text-[#062B45] mb-2">
                  Message
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#1A7A7A] focus:ring-2 focus:ring-[#1A7A7A]/20 outline-none transition-all resize-none"
                  placeholder="Please describe your inquiry in detail..."
                />
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-[#1A7A7A] to-[#0D9DAD] hover:shadow-lg text-white font-bold py-3 px-6 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:shadow-[#0D9DAD]/30"
              >
                Send Message
              </button>

              <p className="text-xs text-gray-500 text-center mt-4">
                We'll get back to you within 24 hours.
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default Contact;
